import styled from 'styled-components';
import { Button } from 'ui/button';
import { buttonShadow, colors, fontSizes, spacing } from 'ui/theme';

export const AddExperimentButton = styled(Button)`
  align-items: center;
  background-color: ${colors.green100};
  border-color: ${colors.green100};
  border-radius: ${spacing.quarter};
  border: solid ${spacing.single} transparent;
  box-shadow: ${buttonShadow.boxShadow};
  color: ${colors.white};
  display: flex;
  position: relative;
  font-size: ${fontSizes.s15};
  line-height: 1;
  padding: ${spacing.half} ${spacing.threeQuarter};
  transition: background-color 0.15s;
  &:focus,
  &:hover {
    outline: none;
    background-color: ${colors.purple100};
    border-color: ${colors.purple100};
    color: ${colors.white};
    text-decoration: none;
  }
  gap: ${spacing.half};
  max-width: fit-content;
`;

export const ExperimentContainer = styled.div`
  display: flex;
  flex-direction: column;
  > :nth-child(2) {
    margin-top: ${spacing.base};
  }
`;
